var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"small-12 medium-12 large-12 hd-12 columns content"},[_c('dean-notification'),_c('div',{staticClass:"row fields"},[_vm._t("left"),_vm._t("center"),_vm._t("right")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }